<template>
	<div>
	<div class="content">
		<div class="content-fill-top">
			<img src="@/assets/top.png" class="top">
		</div>

		<h2>Loppgeneratorn:<br/>Skapa ditt eget midnattslopp!</h2>
		<p>
			Med vår loppgenerator kan du skapa ditt eget digitala midnattslopp i dina kvarter. Designa din egen midnattsloppsbana och bjud in vänner, kollegor och familj att springa på den.
		</p>

		<p>
			Du kan välja mellan att rita banan själv, eller att ladda upp en runda du sprungit och sparat på t. ex. Strava.
		</p>

		<p>
			Den färdiga kartan kan du och dina vänner använda i mobilen för att öva in rundan inför ert eget Digitala Midnattslopp. På loppdagen springer du med Midnattsloppets app igång, och bör inte växla till kartan under loppet.
		</p>
		<p>
			&nbsp;
		</p>
		<brand-button large to="/create">SKAPA MITT MIDNATTSLOPP</brand-button>
		<br /><br/>

	</div>
	<div class="content">
		<h3>MINA KARTOR</h3>
		<div v-if="!$store.getters.signedIn">
			<brand-button secondary to="/signin" >HÄMTA MINA KARTOR</brand-button>
		</div>

		<p v-if="$store.getters.signedIn && $store.state.maps.length == 0">
			Du har inte skapat några kartor.
		</p>

		<div v-if="$store.getters.signedIn && $store.state.maps.length > 0" style="margin-top:1em">
			<div v-for="map in $store.state.maps" :key="map.id" class="map-row">
				<div class="map-row-texts">
					<p class="map-name">{{map.name}}</p>
					<p class="map-url"><a :href="`${base}/${map.id}`" @click="hijackLink">{{`${base}/${map.id}`}}</a></p>
				</div>
				<div class="map-row-buttons">
					<brand-button small class="btn" :to="`/${map.id}`">Visa</brand-button>
					<brand-button small class="btn" :to="`/${map.id}/edit`">Redigera</brand-button>
					<brand-button small class="btn" :to="`/${map.id}/delete`">Radera</brand-button>
				</div>
			</div>
		</div>

		<div v-if="$store.getters.signedIn" class="user">
			<p>Inloggad som {{email}}. <a href="#" @click.prevent="signOut">Logga ut.</a></p>
		</div>


  </div>
  <!-- <div class="content">
		<p>Såhär kan en skapad karta se ut:</p>
		<img src="@/assets/demo.png" class="demo">
	</div> -->
  </div>
</template>

<script>
import { signOut } from '@/api/firebase'

import { mapGetters } from "vuex"
import BrandButton from "../components/BrandButton.vue"


export default {
	name: 'home',
	components: {
		BrandButton,
	},

	methods: {
		signOut() {
			signOut();
		},

		hijackLink(evt) {
			evt.preventDefault();
			this.$router.push(new URL(evt.target.href).pathname);
		}
	},

	computed: {
		base() {
			return window.location.origin;
		},

		email() {
			return this.$store.state.user.email;
		},

		...mapGetters(["signedIn"])
	},

	watch: {
		signedIn: {
			handler(signedIn) {
				if(signedIn) {
					this.$store.dispatch("loadMaps");
				}
			},
			immediate: true
		}
	}
}
</script>

<style scoped>

	.top {
		width: 100%;
	}

	.content-fill-top::after {
		content:'';
		position:absolute;
		left:0; top:0;
		width:100%; height:100%;
		display:inline-block;

		background:
		linear-gradient( rgba(255,255,255, 0) 80%, 
		rgba(255,255,255, 1) 98%);
	}

	.map-row {
		display: flex;
		flex-flow: row nowrap;
		align-items: center;
		margin: .5em -.6em;
		padding: .6em;
	}
	.map-row:hover {
		background-color: #eee;
	}

	.map-row-texts {
		flex: 1 1 auto;
	}

	.map-row-buttons {
		margin-top: 10px;
		flex: 0 0 auto;
		display: flex;
		flex-flow: row nowrap;
	}

	@media (max-width: 550px) {

		.map-row {
			flex-flow: column nowrap;
			align-items: flex-start;
		}
	}


	.btn {
		margin-right: 4px;
		margin-bottom: 4px;
	}

	.map-name, .map-url {
		padding: 0;
		margin: 0;
		word-break: break-word;
	}

	.map-name {
		text-transform: uppercase;
		font-weight: bold;
	}
	.map-url {
		font-size: .8em;
	}

	.map-url a {
		color: #999;
	}

	.user {
		font-size: .8em;
		/* color: #999; */
		margin-bottom: 0;
		margin-top: 2em;
	}
	.user p { margin-bottom: 0 }
</style>